/* SET STATE */
export const SET_STATE_LABREQUESTSURVEYRESP = "SET_STATE_LABREQUESTSURVEYRESP"

/* LABREQUESTSURVEYRESPS */
export const GET_LABREQUESTSURVEYRESPS = "GET_LABREQUESTSURVEYRESPS"
export const GET_LABREQUESTSURVEYRESPS_SUCCESS = "GET_LABREQUESTSURVEYRESPS_SUCCESS"
export const GET_LABREQUESTSURVEYRESPS_FAIL = "GET_LABREQUESTSURVEYRESPS_FAIL"

/* LABREQUESTSURVEYRESP */
export const GET_LABREQUESTSURVEYRESP = "GET_LABREQUESTSURVEYRESP"
export const GET_LABREQUESTSURVEYRESP_SUCCESS = "GET_LABREQUESTSURVEYRESP_SUCCESS"
export const GET_LABREQUESTSURVEYRESP_FAIL = "GET_LABREQUESTSURVEYRESP_FAIL"

/**
 * ADD LABREQUESTSURVEYRESP
 */
 export const ADD_NEW_LABREQUESTSURVEYRESP = "ADD_NEW_LABREQUESTSURVEYRESP"
 export const ADD_LABREQUESTSURVEYRESP_SUCCESS = "ADD_LABREQUESTSURVEYRESP_SUCCESS"
 export const ADD_LABREQUESTSURVEYRESP_FAIL = "ADD_LABREQUESTSURVEYRESP_FAIL"

 /**
 * UPDATE LABREQUESTSURVEYRESP
 */
export const UPDATE_LABREQUESTSURVEYRESP = "UPDATE_LABREQUESTSURVEYRESP"
export const UPDATE_LABREQUESTSURVEYRESP_SUCCESS = "UPDATE_LABREQUESTSURVEYRESP_SUCCESS"
export const UPDATE_LABREQUESTSURVEYRESP_FAIL = "UPDATE_LABREQUESTSURVEYRESP_FAIL"

/**
 * DELETE LABREQUESTSURVEYRESP
 */
export const DELETE_LABREQUESTSURVEYRESP = "DELETE_LABREQUESTSURVEYRESP"
export const DELETE_LABREQUESTSURVEYRESP_SUCCESS = "DELETE_LABREQUESTSURVEYRESP_SUCCESS"
export const DELETE_LABREQUESTSURVEYRESP_FAIL = "DELETE_LABREQUESTSURVEYRESP_FAIL"
